import sfx from "../utils/fx.js";

export default function fx(node, params = {}) {
	node.addEventListener("click", () => {
		sfx("click");
	});

	return {
		update() {

		},

		destroy() {

		}
	};
}